import React from "react";
import { Info } from "lucide-react";
import { Card } from "../../../components/ui/Card";
import { cn } from "../../../libs/utils";

/**
 * Small KPI card: icon chip + label + value. Used for the Batches list
 * summary row (Total/WIP/Completed/NG) and the Batch Details stat row
 * (Total Parts/Yield Rate/Process Time/Current Status) so both screens
 * share one component instead of two near-duplicates.
 */
const BatchStatCard = ({ icon: Icon, label, value, hint, valueClassName, className, children }) => (
  <Card className={cn("px-4 py-3.5", className)}>
    <div className="flex items-center gap-1.5 text-xs font-medium text-slate-500">
      {Icon && (
        <span className="flex h-6 w-6 items-center justify-center rounded-md bg-lightSecondary text-brand">
          <Icon className="h-3.5 w-3.5" />
        </span>
      )}
      <span>{label}</span>
      {hint && (
        <span title={hint} className="text-slate-300">
          <Info className="h-3.5 w-3.5" />
        </span>
      )}
    </div>
    <p className={cn("mt-2 text-2xl font-semibold text-slate-900", valueClassName)}>{value}</p>
    {children}
  </Card>
);

export default BatchStatCard;
